module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAAFCAYAAACzSUsyAAAAAXNSR0IArs4c6QAAALNJREFUeAHt2rENACAIBEB0Cyd2GGc0uAINlUf9obhQkR93R4YhQIAAAQIECBAgQKAkkGeVckIECBAgQIAAAQIECERMCAQIECBAgAABAgQIECBAgAABAgQIECBAoEPAA7pD1U4CBAgQIECAAAECBAgQIECAAAECBAgQ0IB2AwQIECBAgAABAgQIECBAgAABAgQIECDQI6AB3eNqKwECBAgQIECAAAECBAgQIECAAAECBL4XeLw2BFCOjx5OAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/border-top-NC.png
// module id = ripA
// module chunks = 62